import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form } from 'react-bootstrap';
const uuid = require('uuid');
const _ = {
    map: require('lodash/map')
};

const ActivityActions = require('../../actions/ActivityActions');

const propTypes = {
    activity_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    version: PropTypes.string,
    closeHandler: PropTypes.func.isRequired,
};

const defaultProps = {};

const SEVERITY = ['Critical','Major','Moderate','Minor','Minimal'];

class ReportTestResultModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            text: `This will report test results for the activity show`,
            testFailed: false,
            testFailureSeverity: '',
            testNotes: '',
        };

        this.reportTestResultsHandler = this.reportTestResultsHandler.bind(this);
        this.onChangeTestNotes = this.onChangeTestNotes.bind(this);
        this.toggleTestFailed = this.toggleTestFailed.bind(this);
        this.setSeverity = this.setSeverity.bind(this);
    }
    
    reportTestResultsHandler() {
        var failed = this.state.testFailed;
        ActivityActions.reportActivityTest({
            activity_id: this.props.activity_id,
            version: this.props.version,
            failed,
            severity: failed ? this.state.testFailureSeverity : '',
            notes: this.state.testNotes,
        });
        
        this.props.closeHandler();
    }
    
    onChangeTestNotes(e) {
        e.stopPropagation();
        this.setState({ testNotes: e.target.value });
    }
    
    toggleTestFailed(e) {
        e.stopPropagation();
        e.preventDefault();
        this.setState({testFailed: !this.state.testFailed});
    }
    
    setSeverity(e) {
        e.stopPropagation();
        this.setState({testFailureSeverity: e.target.value});
    }
    
    render() {
        return (
            <Modal
                show
                enforceFocus={false}
                autoFocus
                backdrop={false}
                animation={false}
                keyboard={true}
                onHide={this.props.closeHandler}
            >

                <Modal.Header closeButton={this.state.waiting} onHide={this.props.closeHandler}>
                    <Modal.Title>{'Report Test Results'}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {"This will report test results for the current activity"}
                    <Form>
                        <Form.Group controlId="report-test-failed-checkbox">
                            <Form.Label style={{marginRight: '1rem'}}>{'Result:'}</Form.Label>
                            <button className={ this.state.testFailed ? "btn btn-sm btn-danger" : "btn btn-sm btn-success" } id="report-test-failed-checkbox" onClick={this.toggleTestFailed}>
                                {this.state.testFailed ? 'Failed' : 'Passed'}
                            </button>
                        </Form.Group>
                        {this.state.testFailed ?
                        <Form.Group controlId="fail-severity">
                            <Form.Label>{'Severity:'}</Form.Label>
                            <select id="fail-severity" value={this.state.testFailureSeverity} onChange={this.setSeverity}>
                                <option hidden value=''>{'Select...'}</option>
                                {_.map(SEVERITY,(txt,i)=>(
                                <option key={i} value={txt.toLowerCase()}>{txt}</option>
                                ))}
                            </select>
                        </Form.Group>
                        : null }
                        <Form.Group controlId="test-failure-notes">
                            <Form.Label>{'Notes'}</Form.Label>
                            <Form.Control as='textarea' value={this.state.testNotes} onChange={this.onChangeTestNotes}/>
                        </Form.Group>
                    </Form>
                    
                </Modal.Body>

                <Modal.Footer>
                    <span>
                        <Button disabled={this.state.waiting} onClick={this.reportTestResultsHandler} className="margin-right-md">report</Button>
                        <Button disabled={this.state.waiting} onClick={this.props.closeHandler}>cancel</Button>
                    </span>
                </Modal.Footer>
            </Modal>
        );
    }
}

ReportTestResultModal.propTypes = propTypes;
ReportTestResultModal.defaultProps = defaultProps;

export default ReportTestResultModal;